// src/api/mockData.js
const mockPosts = [
  {
    id: 1,
    title: '欢迎来到我的博客',
    summary: '这是 React + Ant Design 的示例博客 Demo（数据存在 localStorage）',
    content: '这是一个基于 React 和 Ant Design 开发的博客系统示例。\n\n主要功能：\n1. 文章的创建、编辑、删除\n2. 文章按标签分类\n3. 按月归档和文件夹管理\n4. 全文搜索功能\n5. 响应式设计\n\n技术栈：\n- React 19\n- Ant Design 6\n- React Router DOM\n- LocalStorage 数据持久化\n\n数据存储在浏览器的 localStorage 中，刷新页面不会丢失。',
    tags: ['React', 'Ant Design', '前端', '教程'],
    createdAt: '2025-12-17 18:27',
    updatedAt: '2025-12-17 18:27',
    viewCount: 156,
    author: '管理员'
  },
  {
    id: 2,
    title: '归档页是怎么分组的？',
    summary: '使用 dayjs 格式化日期实现按 YYYY-MM 分组',
    content: '在归档页面，我们使用 dayjs 库来格式化文章日期，然后按照 YYYY-MM 的格式进行分组。\n\n实现步骤：\n1. 从 localStorage 获取所有文章\n2. 使用 dayjs 提取年份和月份\n3. 按照月份对文章进行分组\n4. 按月份倒序排列显示\n\n文件夹功能：\n除了按月分组，还可以创建自定义文件夹来管理文章。',
    tags: ['dayjs', 'JavaScript', '教程', '归档'],
    createdAt: '2025-12-17 14:32',
    updatedAt: '2025-12-17 14:32',
    viewCount: 89,
    author: '管理员'
  },
  {
    id: 3,
    title: 'React Hooks 使用指南',
    summary: '详细介绍 React Hooks 的使用方法和最佳实践',
    content: 'React Hooks 是 React 16.8 引入的新特性，它允许你在函数组件中使用 state 和其他 React 特性。\n\n常用 Hooks：\n\n1. useState - 管理组件状态\n2. useEffect - 处理副作用\n3. useContext - 跨组件传递数据\n4. useReducer - 复杂状态管理\n5. useCallback - 缓存函数\n6. useMemo - 缓存计算结果\n\n最佳实践：\n1. 只在最顶层使用 Hook\n2. 只在 React 函数中调用 Hook\n3. 使用自定义 Hook 复用逻辑\n4. 合理使用依赖数组',
    tags: ['React', 'Hooks', '教程', 'JavaScript'],
    createdAt: '2025-12-16 10:15',
    updatedAt: '2025-12-16 10:15',
    viewCount: 234,
    author: '管理员'
  },
  {
    id: 4,
    title: 'Ant Design 组件库实战',
    summary: '如何使用 Ant Design 快速构建管理后台',
    content: 'Ant Design 是一个优秀的 React UI 组件库，提供了丰富的组件和良好的设计规范。\n\n主要优点：\n1. 丰富的组件：包含按钮、表单、表格、弹窗等常用组件\n2. 良好的设计语言：统一的设计规范和交互体验\n3. 完善的文档：详细的中文文档和示例代码\n4. 活跃的社区：GitHub 上有大量 star 和贡献者\n5. 企业级应用：许多大型企业都在使用\n\n常用组件：\n1. Button - 按钮组件\n2. Form - 表单组件\n3. Table - 表格组件\n4. Modal - 弹窗组件\n5. Layout - 布局组件\n6. Card - 卡片组件\n7. Menu - 菜单组件\n8. Input - 输入组件',
    tags: ['Ant Design', 'React', 'UI', '前端'],
    createdAt: '2025-12-15 16:45',
    updatedAt: '2025-12-15 16:45',
    viewCount: 187,
    author: '管理员'
  },
  {
    id: 5,
    title: '前端性能优化技巧',
    summary: '提升网站加载速度和用户体验的方法',
    content: '前端性能优化对于提升用户体验至关重要。以下是一些实用的优化技巧：\n\n1. 代码压缩和混淆\n2. 图片优化和懒加载\n3. 使用 CDN 加速资源加载\n4. 减少 HTTP 请求数量\n5. 启用浏览器缓存\n6. 使用 Webpack 代码分割\n7. 移除未使用的 CSS 和 JavaScript\n8. 优化字体加载\n9. 使用 Service Worker\n10. 监控性能指标\n\n工具推荐：\n- Lighthouse\n- WebPageTest\n- Chrome DevTools\n- Bundle Analyzer',
    tags: ['性能优化', '前端', 'JavaScript'],
    createdAt: '2025-12-14 09:30',
    updatedAt: '2025-12-14 09:30',
    viewCount: 142,
    author: '管理员'
  },
  {
    id: 6,
    title: 'CSS Grid 布局完全指南',
    summary: '掌握 CSS Grid 实现复杂网页布局',
    content: 'CSS Grid 是一种强大的二维布局系统，可以轻松实现复杂的网页布局。\n\n基本概念：\n1. 网格容器 (Grid Container)\n2. 网格项 (Grid Items)\n3. 网格线 (Grid Lines)\n4. 网格轨道 (Grid Tracks)\n5. 网格单元格 (Grid Cell)\n6. 网格区域 (Grid Area)\n\n常用属性：\n1. grid-template-columns - 定义列\n2. grid-template-rows - 定义行\n3. grid-gap - 网格间隙\n4. justify-content - 水平对齐\n5. align-items - 垂直对齐\n6. grid-column - 跨列\n7. grid-row - 跨行\n\n响应式设计：\n使用 minmax()、repeat() 和 auto-fit 实现响应式布局。',
    tags: ['CSS', '布局', 'Grid', '前端'],
    createdAt: '2025-12-13 14:20',
    updatedAt: '2025-12-13 14:20',
    viewCount: 98,
    author: '管理员'
  },
  {
    id: 7,
    title: 'TypeScript 入门教程',
    summary: '从 JavaScript 到 TypeScript 的平滑过渡',
    content: 'TypeScript 是 JavaScript 的超集，添加了静态类型检查等功能。\n\n核心特性：\n1. 静态类型检查\n2. 接口和泛型\n3. 枚举类型\n4. 装饰器\n5. 命名空间\n6. 类型推断\n\n基础类型：\n- number\n- string\n- boolean\n- array\n- tuple\n- enum\n- any\n- void\n- null 和 undefined\n- never\n\n高级特性：\n1. 接口 (Interface)\n2. 泛型 (Generics)\n3. 装饰器 (Decorators)\n4. 模块 (Modules)\n5. 命名空间 (Namespaces)\n\n与 React 集成：\n使用 @types/react 和 @types/react-dom 类型定义。',
    tags: ['TypeScript', 'JavaScript', '教程'],
    createdAt: '2025-12-12 11:10',
    updatedAt: '2025-12-12 11:10',
    viewCount: 176,
    author: '管理员'
  },
  {
    id: 8,
    title: '现代前端构建工具比较',
    summary: 'Webpack、Vite、Rollup 和 Parcel 的对比分析',
    content: '现代前端开发离不开构建工具，不同的工具各有优缺点。\n\nWebpack：\n- 功能最全面\n- 插件生态系统丰富\n- 学习曲线较陡\n- 适合大型项目\n\nVite：\n- 开发体验优秀\n- 启动速度极快\n- 基于 ES Module\n- 适合现代项目\n\nRollup：\n- 专注于库打包\n- 输出文件更小\n- Tree-shaking 优秀\n- 适合组件库\n\nParcel：\n- 零配置\n- 开箱即用\n- 自动处理依赖\n- 适合快速原型\n\n选择建议：\n1. 大型应用：Webpack\n2. 现代应用：Vite\n3. 库开发：Rollup\n4. 快速开发：Parcel',
    tags: ['Webpack', 'Vite', '构建工具', '前端'],
    createdAt: '2025-12-11 15:45',
    updatedAt: '2025-12-11 15:45',
    viewCount: 123,
    author: '管理员'
  },
  {
    id: 9,
    title: 'Git 工作流最佳实践',
    summary: '高效团队协作的 Git 使用规范',
    content: 'Git 是现代软件开发中不可或缺的版本控制工具。\n\n常用命令：\n1. git init - 初始化仓库\n2. git add - 添加文件\n3. git commit - 提交更改\n4. git push - 推送代码\n5. git pull - 拉取代码\n6. git branch - 分支管理\n7. git merge - 合并分支\n8. git rebase - 变基操作\n\n工作流：\n1. Git Flow\n2. GitHub Flow\n3. GitLab Flow\n\n最佳实践：\n1. 提交信息规范化\n2. 分支命名规范\n3. 定期合并主分支\n4. 使用 Pull Request 审查代码\n5. 保持提交历史清晰',
    tags: ['Git', '版本控制', '协作'],
    createdAt: '2025-11-25 10:20',
    updatedAt: '2025-11-25 10:20',
    viewCount: 45,
    author: '管理员'
  },
  {
    id: 10,
    title: '移动端适配方案总结',
    summary: '实现多设备完美适配的多种方案',
    content: '移动端适配是现代前端开发的重要课题。\n\n常见方案：\n1. 媒体查询 (Media Queries)\n2. 弹性布局 (Flexbox)\n3. 网格布局 (CSS Grid)\n4. 视口单位 (vw/vh)\n5. 响应式图片\n6. 移动优先设计\n\n工具推荐：\n1. PostCSS 插件\n2. CSS Modules\n3. Styled Components\n4. Tailwind CSS\n\n注意事项：\n1. 触摸事件处理\n2. 移动端性能优化\n3. PWA 支持\n4. 横竖屏适配\n5. 深色模式适配',
    tags: ['移动端', '适配', '响应式', 'CSS'],
    createdAt: '2025-11-20 14:30',
    updatedAt: '2025-11-20 14:30',
    viewCount: 67,
    author: '管理员'
  },
  {
    id: 11,
    title: 'Node.js 基础入门',
    summary: '学习 Node.js 的基本概念和使用方法',
    content: 'Node.js 是一个基于 Chrome V8 引擎的 JavaScript 运行时环境。\n\n核心模块：\n1. fs - 文件系统\n2. path - 路径处理\n3. http - HTTP 服务器\n4. events - 事件处理\n5. stream - 流处理\n\n常用框架：\n1. Express.js\n2. Koa.js\n3. Nest.js\n4. Fastify\n\n应用场景：\n1. Web 服务器\n2. API 开发\n3. 微服务\n4. 命令行工具\n5. 实时应用\n\n学习路径：\n1. JavaScript 基础\n2. Node.js 核心模块\n3. Express 框架\n4. 数据库操作\n5. 部署上线',
    tags: ['Node.js', '后端', 'JavaScript'],
    createdAt: '2025-11-15 09:45',
    updatedAt: '2025-11-15 09:45',
    viewCount: 89,
    author: '管理员'
  },
  {
    id: 12,
    title: 'Docker 容器化部署',
    summary: '使用 Docker 简化应用部署流程',
    content: 'Docker 是一个开源的应用容器引擎，让开发者可以打包他们的应用以及依赖包到一个可移植的容器中。\n\n核心概念：\n1. 镜像 (Image)\n2. 容器 (Container)\n3. 仓库 (Registry)\n4. 网络 (Network)\n5. 数据卷 (Volume)\n\n常用命令：\n1. docker build - 构建镜像\n2. docker run - 运行容器\n3. docker ps - 查看容器\n4. docker images - 查看镜像\n5. docker-compose - 容器编排\n\n部署流程：\n1. 编写 Dockerfile\n2. 构建镜像\n3. 推送到仓库\n4. 服务器拉取\n5. 运行容器',
    tags: ['Docker', '部署', '容器化'],
    createdAt: '2025-11-10 16:20',
    updatedAt: '2025-11-10 16:20',
    viewCount: 56,
    author: '管理员'
  }
];

const initialFolderArticles = {
  'react': [1, 3, 4, 6],
  'tutorial': [1, 2, 3, 7, 8, 11],
  'notes': [2, 5, 6, 9, 10],
  'project': [4, 8, 12]
};

const userPreferences = {
  theme: 'light',
  fontSize: 'medium',
  layout: 'list'
};

const initAppData = () => {
  // 🔴 总是重新设置示例数据
  localStorage.setItem('blogPosts', JSON.stringify(mockPosts));
  localStorage.setItem('folderArticles', JSON.stringify(initialFolderArticles));
  localStorage.setItem('userPreferences', JSON.stringify(userPreferences));
  
  // 只有在没有登录状态时才设置默认值
  if (!localStorage.getItem('isLoggedIn')) {
    localStorage.setItem('isLoggedIn', 'false');
  }
  
  console.log('应用数据初始化完成，已有文章数量:', mockPosts.length);
  console.log('登录状态:', localStorage.getItem('isLoggedIn'));
};
const getAllPosts = () => {
  return JSON.parse(localStorage.getItem('blogPosts') || '[]');
};

const getFolderArticles = () => {
  return JSON.parse(localStorage.getItem('folderArticles') || '{}');
};

export { mockPosts, initialFolderArticles, userPreferences, getAllPosts, getFolderArticles };
export default initAppData;